export default function isIframe() {
  return window.self !== window.top;
}
